import React from "react";

export default function Revolutionary() {
  return (
    <>
      <div className="tp-service-5-area pb-70">
        <div className="container container-1775">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box mb-90">
                <h2 className="tp-service-5-title p-relative tp_fade_right ps-5 ms-5">
                  What Makes Kryptogram Unique?
                </h2>
              </div>
            </div>
          </div>

          {/* <RevealText text="Own a Piece of Kryptogram and Be Part of Tribe O Crypto!" /> */}

          <div className="tp-service-5-wrap">
            <div className="row">
              {/* <div className="col-xxl-3" /> */}
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-1">
                  <div className="tp-service-4-icon">
                    <img
                      src="assets/img/one/real_world_Land_ownership.svg"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-4-content">
                    <h4 className="tp-service-4-title-sm tp-text-black">
                      <a> Real-World Land Ownership</a>
                    </h4>
                    <p>
                      With every 5 Kryptogram NFTs purchased, holders receive
                      100 sq. ft. of land on Kryptogram Island (USA) with
                      invitation to visit the Island , making this a
                      one-of-a-kind NFT-backed real estate opportunity.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-2">
                  <div className="tp-service-4-icon">
                    <img
                      src="assets/img/one/tribe_o_crypto_festival_access.svg"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-4-content">
                    <h4 className="tp-service-4-title-sm tp-text-black">
                      <a>Tribe O Crypto Festival Access</a>
                    </h4>
                    <p>
                      Each Kryptogram NFT serves as an entry ticket to the Tribe
                      O Crypto Festival, the world’s first blockchain-powered
                      music event featuring top DJs, gaming arenas, luxury
                      experiences, and high-end networking.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-3">
                  <div className="tp-service-4-icon">
                    <img
                      src="assets/img/one/scarcity_value_appreciation.svg"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-4-content">
                    <h4 className="tp-service-4-title-sm tp-text-black">
                      <a> Scarcity & Value Appreciation</a>
                    </h4>
                    <p>
                      With only 55,000+200 NFTs available, Kryptogram ensures
                      exclusivity, rarity, and strong future demand, driving
                      long-term asset appreciation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-3">
                  <div className="tp-service-4-icon">
                    <img
                      src="assets/img/one/future_staking_yield_farming_rewards.svg"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-4-content">
                    <h4 className="tp-service-4-title-sm tp-text-black">
                      <a>Future Staking & Yield Farming Rewards</a>
                    </h4>
                    <p>
                      Holders will have the opportunity to stake their
                      Kryptogram NFTs to earn passive income and access
                      exclusive yield farming programs in the future.
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-3">
                  <div className="tp-service-4-icon">
                    <img
                      src="assets/img/one/"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-4-content">
                    <h4 className="tp-service-4-title-sm tp-text-black">
                      <a>Blockchain-Powered Transparency</a>
                    </h4>
                    <p>
                     Built on a secure and decentralized blockchain, Kryptogram guarantees ownership authenticity, secure transactions, and full traceability of assets.

                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
